// extracted by mini-css-extract-plugin
module.exports = {"layout":"style_layout__Cv_wH","layout-body":"style_layout-body__VBSgp"};